import React from 'react';
import RichTextContent from './RichTextContent';

interface CompanyDescriptionProps {
    companyDescription: string;
}

function CompanyDescription({ companyDescription }: CompanyDescriptionProps): React.JSX.Element {
    return (
        <RichTextContent
            html={companyDescription}
            contentEditableClassName="mt-4 mb-10 rounded-lg border border-border bg-muted/50 p-5"
        />
    );
}

export default CompanyDescription;
